export const CASH_WORKSHEET_PRINT_DOCUMENTS = [
  "purchase_agreement",
  "agreement_arbitrate",
  "we_owe",
  "power_attorney",
  "odometer_disclosure",
  "airbag_disclosure",
  "spot_delivery",
  "privacy_notice",
  "tx_title_application",
  "buyers_guide",
  "county_title_issue",
];

const DOCUMENT_KEY_ALIASES = {
  agreement_to_arbitrate: "agreement_arbitrate",
};

const normalizeDocumentKey = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/-/g, "_")
    .replace(/\s+/g, "_");

export const getDocumentKey = (doc) => {
  const raw =
    doc?.value ??
    doc?.attributes?.value ??
    doc?.name ??
    doc?.attributes?.name ??
    doc?.document_name ??
    doc?.document?.name ??
    "";
  const normalized = normalizeDocumentKey(raw);
  return DOCUMENT_KEY_ALIASES[normalized] || normalized;
};

const getDocumentSortOrder = (doc) => {
  const sortValue = doc?.sort ?? doc?.attributes?.sort;
  const parsed = Number(sortValue);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const sortDocumentsByOrder = (docs) =>
  [...docs].sort((a, b) => getDocumentSortOrder(a) - getDocumentSortOrder(b));

export const filterDocumentsForWorksheetType = (docs, worksheetType) => {
  if (!Array.isArray(docs)) return [];

  let filtered = docs;

  if (worksheetType === "cash") {
    const allowed = new Set(CASH_WORKSHEET_PRINT_DOCUMENTS);
    filtered = docs.filter((doc) => allowed.has(getDocumentKey(doc)));
  }

  return sortDocumentsByOrder(filtered);
};
